import * as React from "react"

function IconSafety(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      {...props}
    >
      <title>{"Safety"}</title>
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#E3E833"
          strokeWidth={2}
          d="M30 13l18 32H12zM30 38.943V30.5M30 28.443V26"
        />
      </g>
    </svg>
  )
}

export default IconSafety
